// extracted by mini-css-extract-plugin
export default {"modify_order_header":"ly","center":"my","empty":"ny","pending":"oy","referralTitle":"py","wrapper":"qy","title":"ry","tabs":"sy","tab":"ty","active":"uy","btn":"vy","rewards_table":"wy"};
    if(module.hot) {
      // 1730991502663
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  